import { render, staticRenderFns } from "./SMSTemplateTextarea.vue?vue&type=template&id=6ab0757a&"
import script from "./SMSTemplateTextarea.vue?vue&type=script&lang=js&"
export * from "./SMSTemplateTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports